import Vue from 'vue'
import Router from 'vue-router'

const home = r => require.ensure([], () => r(require('@/components/home')), 'home')
const center = r => require.ensure([], () => r(require('@/components/center')), 'center')

const course_list = r => require.ensure([], () => r(require('@/components/course/list')), 'course_list')
const course_detail = r => require.ensure([], () => r(require('@/components/course/detail')), 'course_detail')

const temporary = r => require.ensure([], () => r(require('@/components/temporary')), 'temporary')

const apply = r => require.ensure([], () => r(require('@/components/apply')), 'apply')
const certificate = r => require.ensure([], () => r(require('@/components/certificate')), 'certificate')


const author = r => require.ensure([], () => r(require('@/components/author')), 'author')

Vue.use(Router)

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

const router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 0)
    })
  },
  routes: [
    {
      path: '/',
      redirect: 'home'
    },
    {
      path: '/home',
      name: 'home',
      component: home,
    },
    {
      path: '/center',
      name: 'center',
      component: center,
    },
    {
      path: '/course/list',
      name: 'course_list',
      component: course_list,
    },
    {
      path: '/course/detail',
      name: 'course_detail',
      component: course_detail,
    },
    
    {
      path: '/temporary',
      name: 'temporary',
      component: temporary,
    },
    {
      path: '/apply',
      name: 'apply',
      component: apply,
    },
    {
      path: '/certificate',
      name: 'certificate',
      component: certificate,
    },

    {
      path: '/author',
      name: 'author',
      component: author,
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js